<div *ngIf="isInitializing()" class="text-center py-3">
    <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
</div>

<div *ngIf="!isInitializing()">
<div class="holes-container" style="max-height: 70vh; overflow-y: auto;" (scroll)="onScroll($event)">
    <div *ngFor="let hole of holesDeliveryControl()?.controls; index as j;">
        <div [formGroup]="$any(hole)" class="row rounded border border-1 shadow  mb-2 p-1 m-2">

        <div class="container mt-4" style="font-size: 14px;">
            <div class="row">
                <div class="col-1 d-flex align-items-center justify-content-center">
                    <input type="checkbox" formControlName="selectedForSplit" class="custom-checkbox" />
                </div>

                <div class="col-10">
                    <div class="row">
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.HOLE_ID' | translate }}</div>
                            <div>{{hole.get('holeId').value}}</div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.DRILLED_DEPTH' | translate }}</div>
                            <div>{{hole.get('drilledDepth').value}}</div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.MEASURED_DEPTH' | translate }}</div>
                            <div>{{hole.get('measuredDepth').value}}</div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.QUANTITY_CARTRIDGE' | translate }}</div>
                            <div>{{snapQuantity(hole.get('cartdridge').value) | number:'1.0-1'}}</div>
                        </div>
                        <div class="col-8 col-md-4">
                            <div class="text-muted">{{ 'DELIVERY.HOLE_CONDITIONS' | translate }}</div>
                            <div [title]="getHoleConditionLabel(hole.get('holeCondition').value)">
                                {{truncateText(getHoleConditionLabel(hole.get('holeCondition').value))}}
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.QUANTITY_KG' | translate }}</div>
                            <div>{{hole.get('kgSend').value}}</div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.FINAL_DEPTH' | translate }}</div>
                            <div>{{hole.get('finalStemmingDepth').value}}</div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.DETOS' | translate }}</div>
                            <div>
                                {{ getDetosCount($any(hole)) }}
                            </div>
                        </div>
                        <div class="col-4 col-md-2">
                            <div class="text-muted">{{ 'DELIVERY.QUANTITY_BOOSTER' | translate }}</div>
                            <div>{{hole.get('booster')?.value}}</div>
                        </div>
                        <div class="col-8 col-md-4">
                            <div class="text-muted">{{ 'DELIVERY.COMMENTS' | translate }}</div>
                            <div [title]="hole.get('comment')?.value">
                                {{ hole.get('comment')?.value ? truncateText(hole.get('comment').value) : '' }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-1 d-flex align-items-center justify-content-center">
                    <button class="btn p-0 d-flex align-items-center" (click)="toggleDetails(j)">
                        <img [src]="isDetailsVisible()[j] ? 'assets/icon/arraw-up.svg' : 'assets/icon/arraw-down.svg'" />
                    </button>
                </div>
            </div>
        </div>

        <div class="container mt-3 mb-3" [ngStyle]="{'display': isDetailsVisible()[j] ? 'block' : 'none'}" >
            <hr />
            <div class="row">
                <div class="col-md-4 mb-1 text-center">
                    <label for="type" class="form-label text-muted">{{ 'DELIVERY.HOLE_ID' | translate }}</label>
                    <input type="text" class="form-control input-field" id="type" formControlName="holeId">
                </div>
                <div class="col-md-4 mb-1 text-center">
                    <label for="name" class="form-label text-muted">{{ 'DELIVERY.DRILLING_DEPTH' | translate }}
                        (m)</label>
                    <input type="text" class="form-control input-field" id="name" formControlName="drilledDepth">
                </div>

                <div class="col-md-4 mb-1 text-center">
                    <label for="name" class="form-label text-muted">{{ 'DELIVERY.MEASURED_DEPTH' | translate }}
                        (m)</label>
                    <input type="text" class="form-control input-field" id="name" formControlName="measuredDepth">
                </div>
            </div>


            <div class="row">
                <div class="col-md-12 mb-1 text-center">
                    <label for="type" class="form-label text-muted">{{ 'DELIVERY.HOLE_CONDITIONS' | translate }}
                    </label>
                    <ng-select [items]="deliveryParams()?.holeConditions" [multiple]="true" [closeOnSelect]="false"
                        bindLabel="shortName" placeholder="Hole conditions" name="holeCondition" id="holeCondition"
                        [clearSearchOnAdd]="true" formControlName="holeCondition" dropdownPosition="top"
                        class="custom select-field-dopdown-checkbox" (clear)="clearConditions()">
                    </ng-select>

                </div>
            </div>


            <div *ngFor="let deto of $any(hole.get('detos'))?.controls; index as j;">
                <div [formGroup]="$any(deto)" class="row">
                    <div class="col-6  text-center">
                        <label for="type" class="form-label text-muted">{{ 'DELIVERY.DETONATOR_TYPE' | translate }}
                        </label>
                        <ng-select [items]="deliveryParams()?.detonators" [multiple]="false" [closeOnSelect]="false"
                            bindLabel="commercialName" placeholder="Detonator type" name="productId" id="productId"
                            [clearSearchOnAdd]="true" bindValue="product.id" formControlName="productId"
                            dropdownPosition="top" class="custom select-field-dopdown-checkbox">
                        </ng-select>
                    </div>

                    <div class="col-6  text-center">
                        <label for="count" class="form-label text-muted"> {{ 'DELIVERY.QUANTITY' | translate }} </label>
                        <input type="number" step="1" class="form-control input-field" id="count" formControlName="count"
                               (keydown)="preventDecimalInput($event)" (focus)="rememberQuantity($event, deto.get('count'))" (paste)="allowQuantityText($event, 0)" (drop)="allowQuantityText($event, 0)"
                               (input)="limitToInteger($event, deto.get('count'))">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6  text-center">
                    <label for="cartdridge" class="form-label text-muted">{{ 'DELIVERY.CARTRIDGE_TYPE' | translate }}
                    </label>
                    <ng-select [items]="deliveryParams()?.cartridges" [multiple]="false" [closeOnSelect]="false"
                        bindLabel="fullName" placeholder="Detonator type" name="cartdridge" id="cartdridge"
                        [clearSearchOnAdd]="true" bindValue="product.id" formControlName="cartridgeId"
                        dropdownPosition="top" class="custom select-field-dopdown-checkbox">
                    </ng-select>
                </div>

                <div class="col-6  text-center">
                    <label for="kgSend" class="form-label text-muted">{{ 'DELIVERY.QUANTITY' | translate }} </label>
                    <input type="number" step="0.1" class="form-control input-field" id="kgSend" formControlName="cartdridge"
                           (keydown)="preventScientificInput($event)" (focus)="rememberQuantity($event, hole.get('cartdridge'))" (paste)="allowQuantityText($event, 1)" (drop)="allowQuantityText($event, 1)" (input)="limitToOneDecimal($event, hole.get('cartdridge'))">
                </div>
            </div>

            <div class="row">
                <div class="col-6  text-center">
                    <label for="cartdridge" class="form-label text-muted">{{ 'DELIVERY.BOOSTER_TYPE' | translate }}
                    </label>
                    <ng-select [items]="deliveryParams()?.cartridges" [multiple]="false" [closeOnSelect]="false"
                        bindLabel="fullName" placeholder="Booster type" name="booster" id="booster"
                        [clearSearchOnAdd]="true" bindValue="product.id" formControlName="boosterId"
                        dropdownPosition="top" class="custom select-field-dopdown-checkbox">
                    </ng-select>
                </div>

                <div class="col-6  text-center">
                    <label for="kgSend" class="form-label text-muted">{{ 'DELIVERY.QUANTITY' | translate }} </label>
                    <input type="number" step="1" class="form-control input-field" id="booster" formControlName="booster"
                           (keydown)="preventDecimalInput($event)" (focus)="rememberQuantity($event, hole.get('booster'))" (paste)="allowQuantityText($event, 0)" (drop)="allowQuantityText($event, 0)"
                           (input)="limitToInteger($event, hole.get('booster'))">
                </div>
            </div>

            <div class="row">
                <div class="col-6  text-center">
                    <label for="finalStemmingDepth"
                        class="form-label text-muted">{{ 'DELIVERY.FINAL_DEPTH' | translate }} (m)</label>
                    <input type="number" class="form-control input-field" id="finalStemmingDepth"
                        formControlName="finalStemmingDepth">
                </div>

                <div class="col-6  text-center">
                    <label for="kgSend" class="form-label text-muted">{{ 'DELIVERY.QUANTITY_KG' | translate }} </label>
                    <input type="number" class="form-control input-field" id="kgSend" formControlName="kgSend"
                           (keydown)="preventScientificInput($event)">
                </div>
            </div>

            <div class="row">
                <div class="col-12  text-center">
                    <label for="name" class="form-label text-muted">{{ 'DELIVERY.COMMENTS' | translate }}</label>
                    <textarea id="message" formControlName="comment" class="form-control input-textarea" rows="2"
                        placeholder="Enter your message here...">
                        </textarea>
                </div>
            </div>

            <div class="d-flex justify-content-center p-1 text-center" style="gap: 20px; margin-top: 2rem">
                <button type="button" class="btn btn-sm btn-secondary w-30" [disabled]="isSaving()"
                    (click)="onCancel($any(hole),j)">{{ 'GLOBAL.ANNULER' | translate }}</button>
                <button type="submit" class="btn btn-sm btn-primary w-30" [disabled]="isSaving()"
                    (click)="onSubmit(j)">{{ 'GLOBAL.CONFIRMER' | translate }}</button>
            </div>

        </div>
    </div>
</div>


<div *ngIf="isScrollLoading()" class="loading-overlay">
    <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
</div>

<div class="row m-2">
    <div class="col-md-3">
        {{ 'DELIVERY.SPLIT_DELIVERY' | translate }}
    </div>
    <div class="col-md-9">
        <hr>
    </div>
</div>

<div class="row border border-1  split-delivery  rounded">
    <div class="col-md-10 mb-1 text-center">
        <label for="type" class="form-label text-muted">{{ 'DELIVERY.NEW_LOAD_NAME' | translate }}</label>
        <input type="text" class="form-control input-field" id="type" [(ngModel)]="destDeliveryName" />
    </div>

    <div class="col-md-2" style="margin-top: 2rem;">
        <button type="submit" class="btn btn-sm btn-primary  w-30"
            (click)="onSplitDelivery(destDeliveryName())">{{ 'DELIVERY.SPLIT' | translate }}</button>
    </div>
</div>
</div>
